import { getWorkflowStart as gws } from 'services/api/payway/workflowStart';
import {
  WORKFLOWSTART_START,
  WORKFLOWSTART_SUCCESS,
  WORKFLOWSTART_ERROR,
  WORKFLOWSTART_CLEAR,
  SET_WORKFLOWSTART_DATA,
} from 'actions/payway';

export const getWorkflowStart = params => dispatch => {
  dispatch({ type: WORKFLOWSTART_START });
  return gws(params)
    .then(response => {
      dispatch({
        type: WORKFLOWSTART_SUCCESS,
        payload: response,
      });
    })
    .catch(error => {
      dispatch({
        type: WORKFLOWSTART_ERROR,
        error,
      });
    });
};

export const clearWorkflowStart = () => ({
  type: WORKFLOWSTART_CLEAR,
});

export const setWorkflowStartData = data => ({
  type: SET_WORKFLOWSTART_DATA,
  payload: data,
});
